/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import * as Ledger from '../model/Ledger';
import { ListItem, ListItemIcon, ListItemText, Dialog, DialogContent, Grid } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { LedgerView } from './Ledger';
import { ToolItemAppBar } from './ToolItemAppBar';
import { AppContext } from '../App';
import { AppSettings } from '../model/AppSettings';

export interface DamageHistoryToolItemProps {
    setLeftPlayerLedger: Function;
    leftPlayerLedger: Ledger.Model;
    setRightPlayerLedger: Function;
    rightPlayerLedger: Ledger.Model;
}

export const DamageHistoryToolItem = (props: DamageHistoryToolItemProps) => {
    const settings = React.useContext<AppSettings>(AppContext);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => { setOpen(true); }
    const handleClose = () => { setOpen(false); }

    return (
        <React.Fragment>
            <ListItem button onClick={handleOpen}>
                <ListItemIcon>
                    <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary={"Damage History"} />
            </ListItem>
            <Dialog fullScreen open={open} onClose={handleClose}>
                <ToolItemAppBar handleClose={handleClose} title={"Damage History"} />
                <DialogContent>
                    <Grid container justify="center" alignItems="flex-start">
                        <Grid item xs={6} md={4}>
                            <LedgerView ledger={props.leftPlayerLedger} setLedger={props.setLeftPlayerLedger} player={settings.leftPlayer} />
                        </Grid>
                        <Grid item md={1}></Grid>
                        <Grid item xs={6} md={4}>
                            <LedgerView ledger={props.rightPlayerLedger} setLedger={props.setRightPlayerLedger} player={settings.rightPlayer} />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}